import React from 'react';
import './menu.css';

function Menu () {

    return (
        <section className="menu">
            <h1>Coming Soon</h1>
        </section>
    )

}

export default Menu;